import styled from "styled-components";
import tw from "twin.macro";

export const Wrapper = styled.div`
    ${tw`bg-wood-light py-10 md:py-12`}
`;
